<form [formGroup]="configurationProfileForm">
  <div class="d-flex">
    <h5 class="mt-auto small-caps">Configuration Profile</h5>
    @if (allowToggle()) {
      <button type="button"
              class="btn btn-outline-primary border-0 ms-auto"
              (click)="toggleEditing()">
        @if (!editing) {
          <fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
        } @else {
          <fa-icon [icon]="['far', 'save']"></fa-icon>
        }
      </button>
    }
  </div>
  <table class="table table-sm table-list mb-4">
    <thead>
      <tr>
        <th colspan="2"
            scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th title="A description of the profile, shown on the Detail screen for the profile. This should be descriptive enough to help the user decide whether to install the profile."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="payloadDescription"
                 class="col-form-label">Description</label>
        </th>
        <td>
          @if (!editing) {
            <label for="payloadDescription"
                   class="col-form-label">{{
            configurationProfile()?.payloadDescription
            }}</label>
          } @else {
            <input type="text"
                   class="form-control"
                   id="payloadDescription"
                   formControlName="payloadDescription" />
          }
        </td>
      </tr>

      <tr>
        <th title="A human-readable name for the profile. This value is displayed on the Detail screen. It does not have to be unique."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="payloadDisplayName"
                 class="col-form-label">Display name</label>
        </th>
        <td>
          @if (!editing) {
            <label for="payloadDisplayName"
                   class="col-form-label">{{
            configurationProfile()?.payloadDisplayName
            }}</label>
          } @else {
            <input type="text"
                   class="form-control"
                   id="payloadDisplayName"
                   formControlName="payloadDisplayName" />
          }
        </td>
      </tr>

      <tr>
        <th title="A date on which a profile is considered to have expired and can be updated over the air. This key is only used if the profile is delivered via over-the-air profile delivery."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="payloadExpirationDate"
                 class="col-form-label">Expiration date</label>
        </th>
        <td>
          @if (!editing) {
            <label for="payloadExpirationDate"
                   class="col-form-label">{{
            configurationProfile()?.payloadExpirationDate
            }}</label>
          } @else {
            <input type="text"
                   class="form-control"
                   id="payloadExpirationDate"
                   formControlName="payloadExpirationDate" />
          }
        </td>
      </tr>

      <tr>
        <th title="A reverse-DNS style identifier (com.example.myprofile, for example) that identifies the profile. This string is used to determine whether a new profile should replace an existing one or should be added."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="payloadIdentifier"
                 class="col-form-label">Identifier</label>
        </th>
        <td>
          @if (!editing) {
            <label for="payloadIdentifier"
                   class="col-form-label">{{ configurationProfile()?.payloadIdentifier }}</label>
          } @else {
            <input type="text"
                   class="form-control"
                   id="payloadIdentifier"
                   formControlName="payloadIdentifier" />
          }
        </td>
      </tr>

      <tr>
        <th title="A human-readable string containing the name of the organization that provided the profile."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="payloadOrganization"
                 class="col-form-label">Organization</label>
        </th>
        <td>
          @if (!editing) {
            <label for="payloadOrganization"
                   class="col-form-label">{{
            configurationProfile()?.payloadOrganization
            }}</label>
          } @else {
            <input type="text"
                   class="form-control"
                   id="payloadOrganization"
                   formControlName="payloadOrganization" />
          }
        </td>
      </tr>

      <tr>
        <th title="A globally unique identifier for the profile. The actual content is unimportant, but it must be globally unique."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="payloadUUID"
                 class="col-form-label">UUID</label>
        </th>
        <td>
          @if (!editing) {
            <label for="payloadUUID"
                   class="col-form-label">{{ configurationProfile()?.payloadUUID }}</label>
          } @else {
            <input type="text"
                   class="form-control"
                   id="payloadUUID"
                   formControlName="payloadUUID" />
          }
        </td>
      </tr>

      <tr>
        <th title="Supervised only. If present and set to true, the user cannot delete the profile (unless the profile has a removal password and the user provides it)."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="payloadRemovalDisallowed"
                 class="col-form-label">Removal disallowed</label>
        </th>
        <td>
          @if (!editing) {
            <label for="payloadRemovalDisallowed"
                   class="col-form-label">{{
            configurationProfile()?.payloadRemovalDisallowed
            }}</label>
          } @else {
            <div class="form-check">
              <input id="payloadRemovalDisallowed"
                     formControlName="payloadRemovalDisallowed"
                     type="checkbox"
                     class="form-check-input position-static" />
            </div>
          }
        </td>
      </tr>

      <tr>
        <th title="The only supported value is Configuration."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="payloadType"
                 class="col-form-label">Type</label>
        </th>
        <td>
          <label for="payloadType"
                 class="col-form-label">{{ configurationProfile()?.payloadType }}</label>
        </td>
      </tr>

      <tr>
        <th title="The version number of the profile format. This describes the version of the configuration profile as a whole, not of the individual profiles within it.
              Currently, this value should be 1."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="payloadVersion"
                 class="col-form-label">Version</label>
        </th>
        <td>
          <label for="payloadVersion"
                 class="col-form-label">{{ configurationProfile()?.payloadVersion }}</label>
        </td>
      </tr>

      <tr>
        <th title="The date on which the profile will be automatically removed."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="removalDate"
                 class="col-form-label">Removal date</label>
        </th>
        <td>
          @if (!editing) {
            <label for="removalDate"
                   class="col-form-label">{{ configurationProfile()?.removalDate }}</label>
          } @else {
            <input type="text"
                   class="form-control"
                   id="removalDate"
                   formControlName="removalDate" />
          }
        </td>
      </tr>

      <tr>
        <th title="Number of seconds until the profile is automatically removed. If the RemovalDate keys is present, whichever field yields the earliest date will be used."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="durationUntilRemoval"
                 class="col-form-label">Duration until removal</label>
        </th>
        <td>
          @if (!editing) {
            <label for="durationUntilRemoval"
                   class="col-form-label">{{
            configurationProfile()?.durationUntilRemoval
            }}</label>
          } @else {
            <input type="number"
                   class="form-control"
                   id="durationUntilRemoval"
                   formControlName="durationUntilRemoval" />
          }
        </td>
      </tr>

      <tr>
        <th title=""
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="hasRemovalPasscode"
                 class="col-form-label">Use removal passcode</label>
        </th>
        <td>
          @if (!editing) {
            <label for="hasRemovalPasscode"
                   class="col-form-label">{{
            configurationProfile()?.hasRemovalPasscode
            }}</label>
          } @else {
            <div class="form-check">
              <input id="hasRemovalPasscode"
                     formControlName="hasRemovalPasscode"
                     type="checkbox"
                     class="form-check-input position-static" />
            </div>
          }
        </td>
      </tr>
    </tbody>
  </table>
</form>